import get from "lodash/get";
import InsertUndoToast from "../../../parts/InsertUndoToast";
import { useRillContext } from "../../../rill/RillReact/share/base";
import CalendarWeekComponent from "../../dashboard/calendar/CalendarWeekComponent";
import MultiWeekView from "./components/MultiWeekView";
import WeekDay from "./components/WeekDay";
import WeekDayModal from "./components/WeekDayModal";

const CalendarWeek = () => {
  const { locals } = useRillContext();

  const {
    activeWeek,
    calendarRange,
    endOfWeek,
    query,
    workoutNotes,
    workoutCoachNotes,
    activeUser,
    activeUserToRequest,
    activeExercises,
    athlete,
    dailyStats,
    fromMetric,
    organizationOwner,
    clientConfiguration,
    scheduledSessions,
    scheduledSections,
    athleteFlexibleProgram,
  } = locals;

  const athleteId =
    query.athlete || get(athlete, "_id") || get(activeUser, "_id");

  return (
    <>
      <CalendarWeekComponent
        activeWeek={activeWeek}
        calendarRange={calendarRange || 1}
        endOfWeek={endOfWeek}
        query={query}
        workoutNotes={workoutNotes}
        workoutCoachNotes={workoutCoachNotes}
        activeUser={activeUser}
        activeUserToRequest={activeUserToRequest}
        activeExercises={activeExercises}
        athleteId={athleteId}
        athlete={athlete}
        athleteFlexibleProgram={athleteFlexibleProgram}
        fromMetric={fromMetric}
        organizationOwner={organizationOwner}
        scheduledSessions={scheduledSessions}
        scheduledSections={scheduledSections}
        clientConfiguration={clientConfiguration}
        WeekDay={WeekDay}
        MultiWeekView={MultiWeekView}
        WeekDayModal={WeekDayModal}
        dailyStats={dailyStats}
        withV2Controls
      />
      <InsertUndoToast athleteId={athleteId} />
    </>
  );
};

export default CalendarWeek;
